/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

export const SEARCH_RESULT_PAGE_INFO_FRAGMENT = /* GraphQL */ `
  fragment SearchResultPageInfoFragment on SearchResultPageInfo {
    current_page
    page_size
    total_pages
  }
`;
